
import { mapGetters } from 'vuex'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'



export default {
data () {
return {

}
},

created () {

},

methods: {
clickLike () {
console.log('like')
}
},

computed: {
...mapGetters(['user'])
},

components: {
Group,
Cell
}
}



// WEBPACK FOOTER //
// ./src/pages/user-center/UserCenter.vue